import React, { useEffect } from 'react';
import './Prayas2020.css';

const Prayas2020 = () => {
  useEffect(() => {
    // Initialize Bootstrap collapse if needed
    // If using Bootstrap JS, ensure it's loaded
  }, []);

  return (
    <div className="prayas2020-page">
      <title>Prayas 2020 - Student School Darpan</title>

      {/* <section className="main-content"> */}
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form method="post" action="" id="form1">
                <div className="about formContent top-mrg-150">
                  {/* Breadcrumbs */}
                  <div className="row">
                    <div className="col-12">
                      <ol className="breadcrumb breadcrumb-arrow">
                        {/* <li><a href="">Citizen Window</a></li>
                        <li className="active"><a href="">Prayas</a></li> */}
                      </ol>
                    </div>
                  </div>

                  <div className="contentArea text-left">
                    <div className="col-12">
                      <h1 className="text-center">Prayas</h1>
                      <h4>
                        <span>
                          विद्या प्रवेश कार्यपुस्तिका
                        </span>
                      </h4>

                      <div id="accordion">
                        {/* ===== Section 1: Board Exam Question Bank ===== */}
                        <div>
                          <div className="card-header">
                            <h5 className="mb-0">
                              <span
                                className="accordion-toggle collapsed"
                                data-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapseThree"
                                aria-expanded="true"
                              >
                                बोर्ड परीक्षा की तैयारी के अभ्यासार्थ प्रश्न बैंक
                              </span>
                            </h5>
                          </div>
                          <div
                            id="collapseThree"
                            className="panel-collapse collapse show"
                            data-parent="#accordion"
                          >
                            <div className="table-responsive">
                              <table className="table table-bordered table-striped table-hover nasTable">
                                <thead>
                                  <tr>
                                    <th>क्रमांक</th>
                                    <th>बोर्ड परीक्षा की तैयारी के अभ्यासार्थ प्रश्न बैंक</th>
                                    <th>विषय</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>SMILE - Geography - Class XII (Paper 1)</td>
                                    <td>
                                      <span>
                                        SMILE - Geography - Class XII (Paper 1)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>SMILE - Geography - Class XII (Paper 2)</td>
                                    <td>
                                      <span>
                                        SMILE - Geography - Class XII (Paper 2)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>3</td>
                                    <td>SMILE - Maths - Class XII (Paper 1)</td>
                                    <td>
                                      <span>
                                        SMILE - Maths - Class XII (Paper 1)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>4</td>
                                    <td>SMILE - Maths - Class XII (Paper 2)</td>
                                    <td>
                                      <span>
                                        SMILE - Maths - Class XII (Paper 2)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>5</td>
                                    <td>SMILE - Maths - Class XII (Paper 3)</td>
                                    <td>
                                      <span>
                                        SMILE - Maths - Class XII (Paper 3)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>6</td>
                                    <td>कक्षा-12 वीं -2018</td>
                                    <td>
                                      <b><i>विज्ञान संकाय:-</i></b>
                                      <span>
                                        अनिवार्य हिंदी-अनिवार्य अंग्रेजी-गणित-भौतिक विज्ञान-रसायन विज्ञान - जीव विज्ञान
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>7</td>
                                    <td>कक्षा-12 वीं -2018</td>
                                    <td>
                                      <b><i>कला संकाय :-</i></b>
                                      <span>
                                        हिंदी साहित्य-इतिहास-अर्थशास्त्र-भूगोल
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>8</td>
                                    <td>कक्षा-10 वीं -2018</td>
                                    <td>
                                      <span>
                                        हिंदी-अंग्रेजी-गणित-सामाजिक विज्ञान-विज्ञान-संस्कृत
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* ===== Section 2: Topper Answer Sheets ===== */}
                        <div className="card-header">
                          <h5 className="mb-0">
                            <span
                              className="accordion-toggle collapsed"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="false"
                              href="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              गत बोर्ड परीक्षा में प्रतिभाशाली विद्यार्थियों की उत्तर पुस्तिकाएं
                            </span>
                          </h5>
                        </div>
                        <div id="collapseOne" className="panel-collapse collapse">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover nasTable">
                              <thead>
                                <tr>
                                  <th>क्रमांक</th>
                                  <th>गत बोर्ड परीक्षा में प्रतिभाशाली विद्यार्थियों की उत्तर पुस्तिकाएं</th>
                                  <th>विषय</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* Class XII 2018 */}
                                <tr>
                                  <td>1</td>
                                  <td>कक्षा-12 वीं -2018</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>Accountancy</span>
                                      <span>Business studies</span>
                                      <span>Compulsory English</span>
                                      <span>Compulsory Hindi</span>
                                      <span>Physics</span>
                                      <span>Chemistry</span>
                                      <span>Mathematics</span>
                                      <span>Economics</span>
                                    </div>
                                  </td>
                                </tr>
                                {/* Class X 2018 */}
                                <tr>
                                  <td>2</td>
                                  <td>कक्षा-10 वीं -2018</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>English</span>
                                      <span>Hindi</span>
                                      <span>Mathematics</span>
                                      <span>Science</span>
                                      <span>Social Science</span>
                                      <span>Sanskrit</span>
                                    </div>
                                  </td>
                                </tr>
                                {/* Class X 2019 */}
                                <tr>
                                  <td>3</td>
                                  <td>कक्षा-10 वीं -2019</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>English1</span>
                                      <span>Hindi1</span>
                                      <span>Mathematics1</span>
                                      <span>English2</span>
                                      <span>Hindi2</span>
                                      <span>Mathematics2</span>
                                      <span>Science1</span>
                                      <span>Social Science1</span>
                                      <span>Sanskrit1</span>
                                      <span>Science2</span>
                                      <span>Social Science2</span>
                                      <span>Sanskrit2</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* ===== Section 3: Study Material ===== */}
                        <div className="card-header">
                          <h5 className="mb-0">
                            <span
                              className="accordion-toggle collapsed"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              aria-expanded="false"
                              href="#collapseTwo"
                            >
                              बोर्ड कक्षाओं की तैयारी हेतु अध्ययन सामग्री
                            </span>
                          </h5>
                        </div>
                        <div id="collapseTwo" className="panel-collapse collapse">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover nasTable">
                              <thead>
                                <tr>
                                  <th>क्रमांक</th>
                                  <th>बोर्ड कक्षाओं की तैयारी हेतु अध्ययन सामग्री</th>
                                  <th>विषय</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* Class 10 - 2023 */}
                                <tr>
                                  <td>1</td>
                                  <td>कक्षा-10 वीं -2023</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>English</span>
                                      <span>Hindi</span>
                                      <span>Mathematics</span>
                                      <span>Science</span>
                                      <span>Social Science</span>
                                      <span>Sanskrit</span>
                                    </div>
                                  </td>
                                </tr>
                                {/* Class 12 - 2023 */}
                                <tr>
                                  <td>2</td>
                                  <td>कक्षा-12 वीं -2023</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>English</span>
                                      <span>Hindi</span>
                                      <span>Mathematics</span>
                                      <span>Biology</span>
                                      <span>Chemistry</span>
                                      <span>Physics Question Bank</span>
                                      <span>Accountancy</span>
                                      <span>Business</span>
                                      <span>Economics</span>
                                      <span>Geography</span>
                                      <span>History</span>
                                      <span>Pol. Science</span>
                                      <span>Model Questions of Compulsory Hindi</span>
                                    </div>
                                  </td>
                                </tr>
                                {/* Class 10 - 2018 */}
                                <tr>
                                  <td>3</td>
                                  <td>कक्षा-10 वीं -2018</td>
                                  <td>
                                    <div className="subject-grid">
                                      <span>English</span>
                                      <span>Hindi</span>
                                      <span>Mathematics</span>
                                      <span>Science</span>
                                      <span>Social Science</span>
                                      <span>Sanskrit</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* </section> */}

      {/* Loader */}
      <div
        id="divLoaderImage"
        className="LoaderImage"
        style={{ display: 'none' }}
      ></div>

      {/* Mobile Navigation */}
      <nav className="mobile-nav d-lg-none">
        <ul>
          <li className="home-icon">
            <span title="Portal Home">
              <i className="fa fa-home" aria-hidden="true" />
            </span>
          </li>
          <li><span>Search Schools</span></li>
          <li><span>Search Schemes</span></li>
          <li><span>Prayas</span></li>
          <li><span>NAS Question Bank</span></li>
          <li><span>Board Exam Question Bank</span></li>
          <li><span>Suggestions from citizen</span></li>
          <li className="drop-down">
            <span>Reports</span>
            <ul>
              <li><span>School</span></li>
              <li><span>Student</span></li>
              <li><span>Staff</span></li>
            </ul>
          </li>
        </ul>
      </nav>
      <div className="mobile-nav-overly" />
    </div>
  );
};

export default Prayas2020;